import { IncomeType } from '../graphql/queries';

export const INCOME_DOC_ENCOURAGEMENT_TEXT = {
  [IncomeType.employment]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including pay stubs, bank statements, and W-2s.',
  [IncomeType.other]:
    'To improve your chances of being offered this rental, provide documents that show your income, such as tax returns or statements/letters from government agencies or financial institutions.',
  [IncomeType.selfEmployed]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including 1099, bank statements, tax returns, or any other document that shows your income.',
  [IncomeType.voucher]:
    'To improve your chances of being offered this rental, provide an approval letter from a Housing Authority, housing voucher, or any other document that shows the maximum amount of your housing assistance payment.',
};

export const DOCUMENTS_EXPIRED_TEXT =
  'Some or all of the income documents you previously added have expired. Add the latest documents that support this income.';
